import { apiSlice } from "./apiSlice";

export const complianceSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllCompliances: builder.query({
            query: (params) => ({
                url: `Compliance`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["Compliances"],
        }),

        // Export all data (without pagination) in Excel File
        getExportAllCompliances: builder.query({
            query: (params) => ({
                url: `Compliance`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        getSingleComplianceDetails: builder.query({
            query: ({ complianceId, params }) => ({
                url: `Compliance/${complianceId}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        createCompliances: builder.mutation({
            query: ({ body }) => ({
                url: `Compliance`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Compliances"],
        }),

        updateCompliance: builder.mutation({
            query: ({ body }) => ({
                url: `Compliance`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["Compliances"],
        }),


    }),
});

export const {
    useGetAllCompliancesQuery,
    useLazyGetAllCompliancesQuery,
    useCreateCompliancesMutation,
    useGetSingleComplianceDetailsQuery,
    useLazyGetSingleComplianceDetailsQuery,
    useUpdateComplianceMutation,
    useLazyGetExportAllCompliancesQuery,
} = complianceSlice;